import { apiClient } from '@/api'
import type {
  ZaloOAStatusResponse,
  ZaloConnectRequest,
  ZaloConnectResponse,
  ZaloDisconnectRequest,
  ZaloDisconnectResponse,
  ZaloChatsResponse,
  ZaloMessagesResponse,
  ZaloSendTextRequest,
  ZaloSendImageRequest,
  ZaloSendDocumentRequest,
  ZaloSendMessageResponse,
  ZaloMarkAsReadRequest,
  ZaloMarkAsReadResponse,
} from '@/features/messenger/types/zalo.types'

const BASE_PATH = '/api/v1/messenger-providers/zalo'

export const zaloApi = {
  async getOAStatus(oaId: string): Promise<ZaloOAStatusResponse> {
    const response = await apiClient.get<ZaloOAStatusResponse>(`${BASE_PATH}/status`, {
      params: { oa_id: oaId },
    })
    return response.data
  },

  async connect(body: ZaloConnectRequest): Promise<ZaloConnectResponse> {
    const response = await apiClient.post<ZaloConnectResponse>(`${BASE_PATH}/connect`, body)
    return response.data
  },

  async disconnect(body: ZaloDisconnectRequest): Promise<ZaloDisconnectResponse> {
    const response = await apiClient.post<ZaloDisconnectResponse>(`${BASE_PATH}/disconnect`, body)
    return response.data
  },

  async getChats(params: {
    oa_id: string
    limit?: number
    offset?: number
    search?: string
  }): Promise<ZaloChatsResponse> {
    // DEV-302: курсорная пагинация (page_token — offset-строка)
    const query = {
      oa_id: params.oa_id,
      'pagination.pageSize': params.limit,
      'pagination.pageToken': params.offset ? String(params.offset) : undefined,
      search: params.search,
    }
    const response = await apiClient.get<ZaloChatsResponse>(`${BASE_PATH}/chats`, {
      params: query,
    })
    return response.data
  },

  async getMessages(
    userId: string,
    params: { oa_id: string; limit?: number; offset?: number },
  ): Promise<ZaloMessagesResponse> {
    const encodedUserId = encodeURIComponent(userId)
    // DEV-302: курсорная пагинация (page_token — offset-строка)
    const query = {
      oa_id: params.oa_id,
      'pagination.pageSize': params.limit,
      'pagination.pageToken': params.offset ? String(params.offset) : undefined,
    }
    const response = await apiClient.get<ZaloMessagesResponse>(
      `${BASE_PATH}/chats/${encodedUserId}/messages`,
      { params: query },
    )
    return response.data
  },

  async sendText(body: ZaloSendTextRequest): Promise<ZaloSendMessageResponse> {
    const response = await apiClient.post<ZaloSendMessageResponse>(
      `${BASE_PATH}/messages/text`,
      body,
    )
    return response.data
  },

  async sendImage(body: ZaloSendImageRequest): Promise<ZaloSendMessageResponse> {
    const response = await apiClient.post<ZaloSendMessageResponse>(
      `${BASE_PATH}/messages/image`,
      body,
    )
    return response.data
  },

  async sendDocument(body: ZaloSendDocumentRequest): Promise<ZaloSendMessageResponse> {
    const response = await apiClient.post<ZaloSendMessageResponse>(
      `${BASE_PATH}/messages/document`,
      body,
    )
    return response.data
  },

  async markAsRead(body: ZaloMarkAsReadRequest): Promise<ZaloMarkAsReadResponse> {
    const response = await apiClient.post<ZaloMarkAsReadResponse>(
      `${BASE_PATH}/messages/read`,
      body,
    )
    return response.data
  },
}
